import React, { Component } from 'react';
import { Table, Segment, Header, Button, Popup } from 'semantic-ui-react';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import NonCycleStudentEditWrapper from '../NonCycleStudentForms/NonCycleStudentEditWrapper';
import { toast } from 'react-toastify';
import axios from 'axios';

class NonCycleStudentCompletionDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            student: props.student,
            unlockLoading: false,
        };
        this.onCancel = this.onCancel.bind(this);
    }

    onCancel = () => {
        this.setState({
            editingCompletionDetails: false,
        });
    };

    onEdit = (editedStudent) => {
        this.setState({
            student: editedStudent,
        });
        this.props.onEdit(editedStudent);
    };

    handleUnlockStudent = (studentId) => {
        this.setState({ unlockLoading: true });
        axios.put(`/non-cycle-student/unlock/${studentId}`)
            .then((res) => {
                const updatedStudent = {
                    ...this.state.student,
                    lockedAt: null
                };
                this.onEdit(updatedStudent);
                this.setState({ unlockLoading: false });
                toast(<FormattedMessage id="externalStudent.toast.unlockSuccess"/>);
            })
            .catch((err) => {
                this.setState({ unlockLoading: false });
                toast(<FormattedMessage id="externalStudent.toast.unlockError"/>);
            });
    };

    render() {
        const {
            editingCompletionDetails,
            student,
            unlockLoading
        } = this.state;

        const { isMainOU } = this.props;

        const localStorageRole = localStorage.getItem('activeRole') || '';
        const isAdmin = localStorageRole === 'Administrator' || localStorageRole === 'AIDA';
        const isStudentService = localStorageRole.slice(0, 10) === 'Studentska';

        return (
            <Segment basic compact>
                {editingCompletionDetails ? <NonCycleStudentEditWrapper
                        student={student}
                        completionDetails
                        onCancel={this.onCancel}
                        onEdit={this.onEdit}
                    /> :
                    <Segment.Group>
                        <Segment>
                            <Header as="h3">
                                <Header.Content style={{
                                    display: 'flex',
                                    justifyContent: 'space-between'
                                }}>
                                    {/* <FormattedMessage id="externalStudent.completionDetails"/> */}
                                    <div></div>
                                    {(isStudentService && isMainOU) &&
                                        (<Popup
                                            content={<FormattedMessage id="externalStudent.edit"/>}
                                            position="top center"
                                            trigger={<Button
                                                icon="pencil"
                                                circular
                                                floated="right"
                                                basic
                                                color="green"
                                                disabled={student.lockedAt}
                                                size={'mini'}
                                                onClick={() => {
                                                    this.setState({ editingCompletionDetails: true });
                                                }}
                                            />}/>)}
                                </Header.Content>
                            </Header>
                        </Segment>
                        <Segment>
                            <Table basic="very" compact celled>
                                <Table.Body>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.graduationDate"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.graduationDate ? moment(student.graduationDate)
                                            .format('D. M. YYYY.') : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.certificateNumber"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.certificateNumber}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.dropoutDate"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.dropoutDate ? moment(student.dropoutDate)
                                            .format('D. M. YYYY.') : '-'}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.lockedAt"/>
                                        </Table.Cell>
                                        <Table.Cell style={{
                                            display: 'flex',
                                            justifyContent: 'space-between',
                                            alignItems: 'center'
                                        }}>
                                                    <span>{student.lockedAt ? moment(student.lockedAt)
                                                        .format('D. M. YYYY.') : '-'}</span>
                                            {student.lockedAt && (
                                                <Popup
                                                    content={<FormattedMessage
                                                        id="externalStudent.unlockStudent"/>}
                                                    trigger={
                                                        <Button
                                                            loading={unlockLoading}
                                                            basic
                                                            circular
                                                            color={'blue'}
                                                            icon="unlock"
                                                            size="mini"
                                                            onClick={() => this.handleUnlockStudent(student.id)}
                                                        />
                                                    }
                                                />
                                            )}
                                        </Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.additionalInformation"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.additionalInformation}</Table.Cell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.Cell textAlign="right" style={{ fontWeight: 'bold' }}>
                                            <FormattedMessage id="externalStudent.additionalInformationEng"/>
                                        </Table.Cell>
                                        <Table.Cell>{student.additionalInformationEng}</Table.Cell>
                                    </Table.Row>
                                </Table.Body>
                            </Table>
                        </Segment>
                    </Segment.Group>}
            </Segment>
        );
    }
}

export default NonCycleStudentCompletionDetails;



// WEBPACK FOOTER //
// ./src/views/NonCycleStudent/NonCycleStudentProfile/NonCycleStudentCompletionDetails.js